import './EventCalendar.scss';
import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import EventCalendarToolbar from './Toolbar/Toolbar';
import { CalendarEvent } from '../../Models/calendarEvent';
import EventLineItem from './EventLineItem/EventLineItem';
import classNames from 'classnames';
import { CalendarType } from '../../Constants/calendartype';

export interface EventCalendarProps {
  date: Date;
  events: CalendarEvent[];
  calendarType: CalendarType;
  setDate: (date: { month: string; year: string }) => void;
}

const EventCalendar: React.FC<EventCalendarProps> = ({ date, events, calendarType, setDate }) => {
  const localizer = momentLocalizer(moment);

  const formats = {
    dateFormat: (date, culture, localizer) => localizer.format(date, 'D', culture),
  };

  const components = {
    event: props => <EventLineItem {...props} variant={calendarType} />,
    toolbar: EventCalendarToolbar,
  };

  return (
    <div
      className={classNames('calendar-container', calendarType === 'compact' ? 'calendar-compact' : 'calendar-line')}>
      <Calendar
        date={date}
        localizer={localizer}
        events={events}
        components={components}
        views={['month']}
        formats={formats}
        onNavigate={newDate => setDate({ month: moment(newDate).format('MM'), year: moment(newDate).format('YYYY') })}
        popup
      />
    </div>
  );
};

export default EventCalendar;
